// extracted by mini-css-extract-plugin
export default {"containerWrapper":"signPage_containerWrapper__YC39t"};